/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_USERS_WITH_BOXES = gql`
  query GetUsersWithBoxes(
    $presentationId: MID!
    $invitedByUser: MID
    $options: GetManyOptions
    $filter: UserAndBoxesFilterInput
    $invitedByUserEmail: String
  ) {
    getUsersWithBoxes(
      presentationId: $presentationId
      invitedByUser: $invitedByUser
      options: $options
      filter: $filter
      invitedByUserEmail: $invitedByUserEmail
    ) {
      count
      limit
      skip
      content {
        Referal {
          inviteType
          partition
          inviteNote
          sectionOptType
        }
        inviteStatus
        email
        Boxes {
          id
          totalAmount
          totalAmountInUSD
          amountPaid
          amountPaidInUSD
          paymentStats
          section {
            name
            costumeTypes {
              name
              id
            }
          }
          presentation {
            name
          }
          costumeID
          discount {
            sponserName
            lateAssociation
            type
            discountAmount
          }
          boxStatus
          boxTxes {
            reason
            displayTitle
          }
          items {
            costumeAttribute {
              id
              name
            }
            costumeFeature {
              name
              id
            }
          }
          Referal {
            partition
            inviteType
          }
        }
        firstName
        fullName
        gender
        userId
        createdAt
        creatorUser {
          fullName
          email
        }
        id
        lastName
        vuid
        accountStatus
        role {
          name
          uuid
          state
        }
      }
    }
  }
`;
